import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  content: {
    paddingHorizontal: 25,
  },
  title: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: 20
  },
  iconSelect: {
    width: 17,
    height: 18
  },
  contentSelect: {
    alignSelf: 'center'
  },
  dropdown: {
    width: '50%',
    height: 30,
    marginTop: 15
  },
  textAmount: {
    fontSize: 14,
    color: '#A0A0A0',
    fontWeight: 'bold',
    marginTop: 35,
    textAlign: 'center'
  },
  price: {
    textAlign: 'center',
    fontSize: 12,
    marginTop: 15
  }
});

export default styles;
